"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const MAX_ALLOWED_CHARS = 5;
document.addEventListener("keydown", e => {
    if (!isFinite(e.key))
        return;
    e.preventDefault();
    e.stopPropagation();
    addToEntry(e.key);
});
const enteredELe = document.getElementById("entered");
const removeButton = document.getElementById("keypad-button-remove");
const enteredErrorEle = document.getElementById("entered-error");
const buttons = document.getElementsByClassName("keypad-button");
if (buttons) {
    for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i];
        button.onclick = () => {
            addToEntry(button.value);
        };
    }
}
if (removeButton) {
    removeButton.disabled = !enteredELe || enteredELe.value.length === 0;
    removeButton.onclick = () => {
        removeFromEntry();
    };
}
function onEntryChanged() {
    if (removeButton) {
        removeButton.disabled = !enteredELe || enteredELe.value.length === 0;
    }
    if (enteredErrorEle) {
        enteredErrorEle.textContent = "";
    }
    if (enteredELe && enteredELe.value.length >= MAX_ALLOWED_CHARS) {
        attemptCode(enteredELe.value);
        enteredELe.value = "";
    }
}
if (enteredELe) {
    enteredELe.oninput = () => {
        onEntryChanged();
    };
}
function onEnteredFailed(status) {
    if (!enteredErrorEle) {
        return;
    }
    if (status === 404) {
        enteredErrorEle.textContent = "Der Zugangscode ist ungültig";
        return;
    }
    enteredErrorEle.textContent = "Interner Serverfehler";
}
function attemptCode(code) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const url = `/share/code/${code}`;
            const result = yield fetch(url);
            if (!result.ok) {
                console.error(yield result.text());
                onEnteredFailed(result.status);
                return;
            }
            const data = yield result.json();
            window.location.href = data.link;
        }
        catch (error) {
            console.error(error);
            onEnteredFailed(400);
        }
    });
}
function addToEntry(char) {
    if (!enteredELe)
        return;
    if (enteredELe.value.length >= MAX_ALLOWED_CHARS)
        return;
    const newValue = `${enteredELe.value}${char}`;
    enteredELe.value = newValue;
    onEntryChanged();
}
function removeFromEntry() {
    if (!enteredELe) {
        return;
    }
    if (enteredELe.value.length === 0) {
        return;
    }
    enteredELe.value = enteredELe.value.substring(0, enteredELe.value.length - 1);
}
const createSessionButton = document.getElementById("create-session");
if (createSessionButton) {
    createSessionButton.onclick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield fetch(`/create-bubiza`);
            if (!result.ok) {
                throw yield result.text();
            }
            const data = yield result.json();
            if (data.code) {
                console.log(data.code);
                window.location.href = data.link;
            }
        }
        catch (error) {
            console.error(error);
            if (enteredErrorEle) {
                enteredErrorEle.textContent = `${error}`;
            }
        }
    });
}
